<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app >
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;">报障工单</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon @click.stop="dialog = !dialog">
        <v-icon>mdi-magnify</v-icon>
      </v-btn> -->
      <!-- <v-btn icon>
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn> -->
    </v-app-bar>
    <v-content>
      <div style="margin:0.5rem 0.76rem 0.2rem;">
        <v-tabs v-model="tabTag" color="#5cbbf6" background-color="#f2f2f2" @change="changeTab">
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#0">我的团队</v-tab>
          <v-tab href="#1">我参与的</v-tab>
        </v-tabs>
      </div>
      <v-container>
          <v-card style="margin-bottom:0.7rem;" flat>
            <v-row style="text-align:center;">
              <v-col>
                <div style="font-size:0.9rem;color:#409EFF">待处理</div>
                <div style="font-size:2rem;">{{statData.b0}}</div>
              </v-col>
               <v-col>
                <div style="font-size:0.9rem;color:#FF9900">处理中</div>
                <div style="font-size:2rem;">{{statData.b2}}</div>
              </v-col>
              <v-col>
                <div style="font-size:0.9rem;color:#67C23A">已完成</div>
                <div style="font-size:2rem;">{{statData.b4}}</div>
              </v-col>
            </v-row>
          </v-card>

          <div style="margin-bottom:0.7rem;text-align:right;font-size:0.9rem;color:#9E9E9E;">
              <span style="margin-right:0.6rem;">筛选:</span>
              <i class="fa fa-filter" style="margin-right:0.2rem;" aria-hidden="true"></i>
              <select v-model="listFilter.biz_sid" @change="changeBidSid">
                <option :value="item.value" v-for="(item,index) in stepList" :key="index">{{item.label}}</option>
              </select>
              <i class="fa fa-angle-down" aria-hidden="true" style="font-size:1.2rem;color:#808080;padding:0 0.2rem;float:right;" ></i>
          </div>

          <div v-if="loading">
            <v-skeleton-loader ref="skeleton" type="article" class="mx-auto" style="margin-bottom:1rem;"></v-skeleton-loader>
            <v-skeleton-loader ref="skeleton" type="article" class="mx-auto" style="margin-bottom:1rem;"></v-skeleton-loader>
            <v-skeleton-loader ref="skeleton" type="article" class="mx-auto" style="margin-bottom:1rem;"></v-skeleton-loader>
            <v-skeleton-loader ref="skeleton" type="article" class="mx-auto" style="margin-bottom:1rem;"></v-skeleton-loader>
            <v-skeleton-loader ref="skeleton" type="article" class="mx-auto" style="margin-bottom:1rem;"></v-skeleton-loader>
          </div>
          <div v-else v-for="(item,index) in list" :key="index" class="mx-auto elevation-1">
              <OrderCard :orderInfo="item" style="margin-bottom:1rem;" flat />
          </div>

          <ListFooter :count="list.length" />

          <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="600px">
              <v-card>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field label="请输入客户名称" required></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="dialog = false">取消</v-btn>
                  <v-btn color="blue darken-1" text @click="dialog = false">搜索</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>

      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import OrderCard from './OrderCard'
import ListFooter from '../../components/ListFooter'
export default {
  components: {
    OrderCard,
    ListFooter
  },
  data() {
    return {
      dialog: false,
      list: [],
      listFilter: {
        search_content: '',
        search_fields: ['GZ_TITLE'],
        gz_date_time: [],
        pagination: {
          limit: 30,
          page: 1
        },
        biz_sid: -1
      },
      stepList: [
        {
          label: '全部',
          value: -1
        },
        {
          label: '待处理',
          value: 0
        },
        {
          label: '处理中',
          value: 2
        },
        {
          label: '已完成',
          value: 4
        }
      ],
      statData: {
        b0: 0,
        b2: 0,
        b4: 0
      },
      loading: true,
      tabTag: '1'
    }
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    queryOrderList() {
      var that = this
      that.statOrderCount();
      that.$api.bz.queryOrderList({ str_filter: JSON.stringify(that.listFilter) }).then(res => {
        if (!res.success) {
          that.$toast.error('获取数据失败');
          return
        }
        var data = res.data
        that.list = data.list
        that.listFilter.pagination.total = data.count
        that.loading = false
      })
    },
    changeBidSid() {
      var that = this
      that.initData()
    },
    statOrderCount() {
      var that = this
      that.$api.bz.statGzOrderCount().then(res => {
        if (!res.success) {
          that.$toast.error('获取统计数据失败');
          return
        }
        that.statData = res.data
      })
    },
    statPlayerCount() {
      var that = this
      that.$api.bz.statPlayerCount().then(res => {
        if (!res.success) {
          that.$toast.error('获取统计数据失败');
          return
        }
        that.statData = res.data
      })
    },
    getPlayerOrderList() {
      var that = this
      that.statPlayerCount()
      that.$api.bz.getPlayerOrderList({ bizsid: that.listFilter.biz_sid }).then(res => {
        if (!res.success) {
          that.$toast.error('获取数据失败');
          return
        }
        var data = res.data
        that.list = data
        that.loading = false
      })
    },
    changeTab() {
      this.initData()
    },
    initData() {
      var that = this
      if (that.tabTag === '0') {
        that.queryOrderList()
      } else {
        that.getPlayerOrderList()
      }
    }
  },
  mounted() {
    var that = this
    that.initData()
  },
  activated() {
    var that = this
    that.initData()
  },
  deactivated() {
  }
}
</script>

<style scoped>

.us-v-app{
  background-color: #f2f2f2 !important;
}

.us-v-app /deep/ .theme--light.v-tabs-items{
  background-color: #f2f2f2 !important;
}

.us-v-app /deep/ .v-tab--active{
  font-size: 0.96rem;
}

</style>
